// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zD-z","tooltipWrapper":"AD-z","icon":"BD-z","tooltip":"CD-z","content":"DD-z"};